const ethers = require("ethers");

function ERC20BalanceOf(token, address, signerOrProvider) {
  const contract = new ethers.Contract(token, ["function balanceOf(address) view returns (uint256)"], signerOrProvider);
  return contract.balanceOf(address);
}

function ERC20Approve(token, spender, amount, signerOrProvider) {
  const contract = new ethers.Contract(token, ["function approve(address, uint256) returns (bool)"], signerOrProvider);
  return contract.approve(spender, amount);
}

function ERC20Mint(token, to, amount, signerOrProvider) {
  const contract = new ethers.Contract(token, ["function mint(address, uint256)"], signerOrProvider);
  return contract.mint(to, amount);
}

function ERC1155BalanceOf(contractAddress, id, address, signerOrProvider) {
  const contract = new ethers.Contract(
    contractAddress,
    ["function balanceOf(address, uint256) view returns (uint256)"],
    signerOrProvider
  );
  return contract.balanceOf(address, id);
}

function ERC1155BalanceOfBatch(contractAddress, ids, addresses, signerOrProvider) {
  const contract = new ethers.Contract(
    contractAddress,
    ["function balanceOfBatch(address[] owners, uint256[] ids) view returns (uint256[] balances)"],
    signerOrProvider
  );
  return contract.balanceOfBatch(addresses, ids);
}

module.exports = { ERC20BalanceOf, ERC20Approve, ERC20Mint, ERC1155BalanceOf, ERC1155BalanceOfBatch };
